import { render, staticRenderFns } from "./ListRule.vue?vue&type=template&id=4026ff11&scoped=true&"
import script from "./ListRule.vue?vue&type=script&lang=js&"
export * from "./ListRule.vue?vue&type=script&lang=js&"
import style0 from "./ListRule.vue?vue&type=style&index=0&id=4026ff11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4026ff11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
